<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title dark>Курсы</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs fixed-tabs color="primary" active-class="active-tab">
          <v-tabs-slider color="#FDE700"></v-tabs-slider>
          <v-tab ref="courses" key="courses_list" dark color="#FDE700" :to="{ name: 'hps_course' }"
            >Курсы
          </v-tab>
          <v-tab key="hps_teachers_list" :to="{ name: 'hps_teacher' }"> Преподаватели </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-col>
      <router-view name="hps_courses"></router-view>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: 'hps_course_index',
  data() {
    return {
      courses: [],
      teachers: [],
    }
  },
  mounted() {
    this.axios({
      url: '/v1/hps/courses',
      method: 'get',
    })
      .then((res) => {
        this.courses = res.data
      })
      .catch((err) => {
        this.showSnackbar(err.response ? err.response.data : err, 'error')
      })
    this.axios({
      url: '/v1/hps/teachers',
      method: 'get',
    })
      .then((res) => {
        this.teachers = res.data
      })
      .catch((err) => {
        this.showSnackbar(err.response ? err.response.data : err, 'error')
      })
  },
}
</script>
